import PropTypes from 'prop-types';
import React,{ useState }  from 'react'
import { useEffect } from 'react'
import { BarChartContainer, Border } from '../style'
import VerticalBarChart from './VerticalBarChart';
import { RecognitionUpArrow, DemoCategory, EmojiModerate, EmojiGood, EmojiHappy } from '../../../../utils/icons';
import { CommonFilterDropdown } from '../../../common/CommonYearFilter/CommonYearFilter';
import { commaSeperator } from "../../../../utils/methods";

const MonthlyBarChart = ({heading="Top Performing Managers | Overall",total="0",totalText="Miles",widthType="half",barColorActive="#A65C7C", barColor="#CE98B3",showCategory, dataGraph, totalPercentage, isDynamicMonth, dynamicMonthsName, data=    [
  {
    "full_name": "Ajay Sharma",
    "total_recognitions": isDynamicMonth?dataGraph[0]?.count: dataGraph?.Jan,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Arpit Malviya",
    "total_recognitions": isDynamicMonth?dataGraph[1]?.count:dataGraph?.Feb,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Eshwar Deshmukh",
    "total_recognitions": isDynamicMonth?dataGraph[2]?.count: dataGraph?.Mar,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Dhairya Vora",
    "total_recognitions": isDynamicMonth?dataGraph[3]?.count: dataGraph?.Apr,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Dhairya Vora",
    "total_recognitions":isDynamicMonth?dataGraph[4]?.count: dataGraph?.May,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Dhairya Vora",
    "total_recognitions": isDynamicMonth?dataGraph[5]?.count:dataGraph?.Jun,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Dhairya Vora",
    "total_recognitions": isDynamicMonth?dataGraph[6]?.count:dataGraph?.Jul,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Dhairya Vora",
    "total_recognitions": isDynamicMonth?dataGraph[7]?.count:dataGraph?.Aug,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Dhairya Vora",
    "total_recognitions": isDynamicMonth?dataGraph[8]?.count:dataGraph?.Sep,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Ajay Sharma",
    "total_recognitions": isDynamicMonth?dataGraph[9]?.count:dataGraph?.Oct,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Ajay Sharma",
    "total_recognitions":isDynamicMonth?dataGraph[10]?.count: dataGraph?.Nov,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
  {
    "full_name": "Ajay Sharma",
    "total_recognitions":isDynamicMonth?dataGraph[11]?.count: dataGraph?.Dec,
    image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
  },
],id, type}) => {
  const activityOptions = ["Step","Calories","Distance","Time"];
  const [selectedActivity, setSelectedActivity] = useState("Step");
  useEffect(()=>{
  },[]);

  const effectiveData = (isDynamicMonth && dynamicMonthsName?.length)
    ? dynamicMonthsName.map((month) => ({
      full_name: month,
      total_recognitions: dataGraph?.[month] ?? 0,
      image: "https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png"
    }))
    : data;

  
  const graphRender = (data, id) => {

    const topActivities = data.map((item, answerIndex) => ({
      y: Math.round(item.total_recognitions),
      color:  getColorByIndex(answerIndex), // You can define getColorByIndex function
      image: item.image
    }));
    const maxValue = Math.max(...topActivities.map((activity) => activity.y));
    const xAxisLabels = ["Jan", "Feb","Mar","April","May", "Jun","Jul","Aug","Sep", "Oct","Nov","Dec"];
    const yAxisLabels = ['25%', '50%', '75%', '100%'];
    const dataValue = [{
      name: '',
      data: topActivities,
      showInLegend: false,
      color: '#DE9444'
    }];
    const splineData = {
      name: '',
      type: 'line',
      color: '#DF8500',
      lineWidth: 2,
      showInLegend: false,
      // yAxis: 1, // Use the second yAxis (the one with offset)
      zones: [
        { value: 20, color: barColor },
        { value: 40, color: barColor },
        { value: 60, color: barColor },
        { value: 80, color: barColor },
        { value: 100, color: barColor }
      ],
      data: data.map((item) => item.total_recognitions > 100 ? 100 : item.total_recognitions),
      tooltip: {
        pointFormat:
          '<span style="font-weight: bold; color: {series.color}">' +
          '{series.name}</span>: <b>{point.y} recognitions</b>'
      }
    };
    return (
      <div className="bargraph">
        <VerticalBarChart
          id={`${id} ${123}`}
          seriesData={dataValue}
          xAxisLabel={isDynamicMonth?dynamicMonthsName: xAxisLabels}
          yAxisVisible={yAxisLabels}
          fillColor={1}
          cultureSurvey={1}
          width={"30px"}
          widthType={widthType}
          splineData={splineData}
          maxValue={maxValue}
        />
      </div>)
  }

  function getColorByIndex(index) {
    // Define an array of colors or generate colors dynamically
    const colors = [barColor,barColor,barColor,barColor,barColor,barColor,barColor,barColor,barColor,barColor,barColor,barColorActive];
  
    // Return the color based on the index, repeating if necessary
    return colors[index % colors.length];
  }

  const checkSign = (input) => {
    if (input > 0) {
      return "plus";
    } else if (input < 0) {
      return "minus";
    }
    return "none";
  }
  return (
    <>
      <BarChartContainer>
        <div className='heading'>{heading}
          {showCategory&&<span className='dropdown'>
            <CommonFilterDropdown
              options={activityOptions}
              selectedOption={selectedActivity}
              setSelectedOption={setSelectedActivity}
              dropdownHeight="auto"
            />
          </span>}
        </div>
        <Border/>

        <div className='total-row'>
          {showCategory&&<span className='image'>
            <DemoCategory/>
          </span>}
          <span className='total'>{commaSeperator(total)}</span>
          <span className='total-text'>{totalText}</span>
          {type==="monthly-theme"&&<>
            <span className="border"/>
            <span className="emoji-users">
              <div className="emoji"><EmojiModerate/></div>
              <div className="help">Helped a Bit</div>
              <div className="user">50 Users</div>
            </span>
            <span className="emoji-users">
              <div className="emoji"><EmojiGood/></div>
              <div className="help">Great and Useful</div>
              <div className="user">50 Users</div>
            </span>
            <span className="emoji-users">
              <div className="emoji"><EmojiHappy/></div>
              <div className="help">Made My Day!</div>
              <div className="user">50 Users</div>
            </span>
          </>}
          {showCategory&&<span className='average'>
            <div className='daily' style={{marginBottom:"4px"}}>
              <span className="round"></span>
              <span className='value'>7 Miles</span>
              <span className='subtext'>| Average Daily Distance Per Employee</span>
            </div>
            <div className='daily'>
              <span className="round"></span>
              <span className='value'>210 Miles</span>
              <span className='subtext'>| Average Monthly Distance Per Employee</span>
            </div>
          </span>}
        </div>
        <div className='compare-row'>
          <div className={checkSign(totalPercentage)}><span className='icon' style={{transform:checkSign(totalPercentage)=="plus"?'':'rotate(180deg)'}}>{checkSign(totalPercentage)!=="none"&&RecognitionUpArrow()}</span>{totalPercentage?totalPercentage:"0"} % </div>
          <div className='text'>{" vs last month"}</div>
        </div>
        <div>{graphRender(effectiveData, id || total)}</div>
          
      </BarChartContainer>
    </>
  )
}

MonthlyBarChart.propTypes = {
  heading: PropTypes.string,
  total: PropTypes.number,
  totalPercentage: PropTypes.number,  
  totalText: PropTypes.string,
  data: PropTypes.array,
  widthType:PropTypes.string,
  id:PropTypes.any,
  barColor:PropTypes.string,
  barColorActive: PropTypes.string,
  showCategory: PropTypes.string,
  type: PropTypes.string,
  dataGraph: PropTypes.array,
  isDynamicMonth: PropTypes.bool,
  dynamicMonthsName: PropTypes.array
}

export default MonthlyBarChart;
